import React from 'react';
import styles from '../../css-modules/Quote.module.css';

const Quote = () => (
  <div className={styles.quote}>
    <p>
      Math magician is not all about numbers, equation,
      computation or algorithm. it is all about understanding
      -William paul Thurston
    </p>
  </div>
);

export default Quote;
